import React, { useEffect, useMemo } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { getRemarks } from '../../actions/admin';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

export const TermsAndCondtion = ({ editorRef, org_id = '' }) => {
    const dispatch = useDispatch();
    const termsAndConditions = useSelector((state) => state.org.termsAndConditions);

    useEffect(() => {
        if (org_id) {
            dispatch(getRemarks({ limit: 100, page: 1, query: '', org_id: org_id, category: 'PO_TERMS', dropdown: true }));
        }
    }, [org_id, dispatch]);

    const term = useMemo(() => {
        if (org_id && termsAndConditions && termsAndConditions[org_id]) {
            return termsAndConditions[org_id];
        }
        return '';
    }, [org_id, termsAndConditions]);

    return (
        <Editor
            apiKey='kws9xlqkjtannzo9nd51s2q0c3p0bt0ixceobd9aqd9vdfy7'
            onInit={(evt, editor) => (editorRef.current = editor)}
            initialValue={term}
            init={{
                statusbar: false,
                height: 300,
                menubar: false,
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount',
                ],
                toolbar:
                    'fontselect fontsizeselect formatselect | ' +
                    'bold italic underline link strikethrough | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'forecolor backcolor removeformat | print help',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:12px }',
            }}
        />
    );
};
